<template>
  <!-- Add Coupons -->
  <div class="modal fade" id="add_coupons">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="mb-0">Add Coupon</h5>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x fs-16"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Coupon Name <span class="text-danger">*</span></label
                >
                <input type="text" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Coupon Code <span class="text-danger">*</span></label
                >
                <input type="text" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label">Type <span class="text-danger">*</span></label>
                <vue-select :options="FixSele" id="fixsele" placeholder="Select" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Discount Value <span class="text-danger">*</span></label
                >
                <input type="text" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Start Date <span class="text-danger"> *</span>
                </label>
                <div class="input-icon-end position-relative">
                  <datepicker
                    v-model="startdate"
                    class="form-control datetimepicker"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >End Date <span class="text-danger"> *</span>
                </label>
                <div class="input-icon-end position-relative">
                  <datepicker
                    v-model="startdateOne"
                    class="form-control datetimepicker"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Applicable To <span class="text-danger">*</span></label
                >
                <vue-select :options="FixRentals" id="fixrentals" placeholder="Select" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label">Limit <span class="text-danger">*</span></label>
                <input type="text" class="form-control" />
                <span class="text-gray-5 fs-13 mt-1">Enter 0 for unlimited</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="mb-0">
                <label class="form-label">Description </label>
                <div class="editor">
                  <ckeditor
                    :editor="editor"
                    v-model="editorData"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
                <p class="mt-2 fs-14">Maximum 60 Words</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary"
              >Create New</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Coupons -->

  <!-- Edit Coupons -->
  <div class="modal fade" id="edit_coupons">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="mb-0">Edit Coupon</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x fs-16"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Coupon Name <span class="text-danger">*</span></label
                >
                <input type="text" value="Summer Sale 2025" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Coupon Code <span class="text-danger">*</span></label
                >
                <input type="text" value="SUMMER2024" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label">Type <span class="text-danger">*</span></label>
                <vue-select
                  :options="EditFixSele"
                  id="editfixsele"
                  placeholder="Percentage"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Discount Value <span class="text-danger">*</span></label
                >
                <input type="text" value="25%" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Start Date <span class="text-danger"> *</span>
                </label>
                <div class="input-icon-end position-relative">
                  <datepicker
                    v-model="startdate"
                    class="form-control datetimepicker"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >End Date <span class="text-danger"> *</span>
                </label>
                <div class="input-icon-end position-relative">
                  <datepicker
                    v-model="startdateOne"
                    class="form-control datetimepicker"
                    :editable="true"
                    :clearable="false"
                    :input-format="dateFormat"
                  />
                  <span class="input-icon-addon">
                    <i class="ti ti-calendar"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label"
                  >Applicable To <span class="text-danger">*</span></label
                >
                <vue-select
                  :options="EditFixRentals"
                  id="editfixrentals"
                  placeholder="New Customers"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="mb-3">
                <label class="form-label">Limit <span class="text-danger">*</span></label>
                <input type="text" value="15" class="form-control" />
                <span class="text-gray-5 fs-13 mt-1">Enter 0 for unlimited</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="mb-0">
                <label class="form-label">Description </label>
                <div class="editor">
                  <ckeditor
                    :editor="editor"
                    v-model="editorData"
                    :config="editorConfig"
                  ></ckeditor>
                  20% off on all rentals in January to March.
                </div>
                <p class="mt-2 fs-14">Maximum 60 Words</p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary"
              >Save Changes</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Coupons -->

  <!-- Delete Modal  -->
  <div class="modal fade" id="delete_coupons">
    <div class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-body text-center">
          <span
            class="avatar avatar-lg bg-transparent-danger rounded-circle text-danger mb-3"
          >
            <i class="ti ti-trash-x fs-26"></i>
          </span>
          <h4 class="mb-1">Delete Coupon</h4>
          <p class="mb-3">Are you sure you want to delete Coupon?</p>
          <div class="d-flex justify-content-center">
            <a
              href="javascript:void(0);"
              class="btn btn-light me-3"
              data-bs-dismiss="modal"
              >Cancel</a
            >
            <a href="javascript:void(0);" data-bs-dismiss="modal" class="btn btn-primary"
              >Yes, Delete</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Delete Modal-->
</template>
<script>
import { ref } from "vue";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      dateFormat: "dd-MM-yyyy",
      startdate: currentDate,
      startdateOne: currentDateOne,
      FixRentals: [
        "Select",
        "New Customers",
        "Weekly Rentals",
        "VIP Members",
        "Luxury Cars",
        "Long Rentals",
      ],
      FixSele: ["Select", "Percentage", "Fixed"],
      EditFixRentals: [
        "Select",
        "New Customers",
        "Weekly Rentals",
        "VIP Members",
        "Luxury Cars",
        "Long Rentals",
      ],
      EditFixSele: ["Select", "Percentage", "Fixed"],
      editor: ClassicEditor,
      editorData: " ",
      editorConfig: {},
    };
  },
};
</script>
